module.exports = __webpack_public_path__ + "static/media/call_you_later.2f4d0a36.png";